// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__ButtonPrimaryMobile from "../../components/html/ButtonPrimaryMobile.js";
import * as Buhta_cabinet__PdfCanvas from "./PdfCanvas.js";
import * as Buhta_cabinet__SignDocumentInfo from "./SignDocumentInfo.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import QrcodeReact from "qrcode.react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(data) {
  return function (code) {
    const match = React.useState(function () {
          return false;
        });
    const setDropdownVisible = match[1];
    const dropdownVisible = match[0];
    const match$1 = React.useState(function () {
          return "100vh";
        });
    const setScreenHeight = match$1[1];
    const match$2 = React.useState(function () {
          return 0;
        });
    const setActiveFile = match$2[1];
    const activeFile = match$2[0];
    const match$3 = React.useState(function () {
          return false;
        });
    const setSignModalVisible = match$3[1];
    const signable = Belt__Belt_List.getExn(data.signables, activeFile);
    const previewUrl = Belt__Belt_Option.getExn(signable.document).preview_url;
    React.useEffect((function () {
            const availHeight = window.innerHeight;
            Curry._1(setScreenHeight, (function (param) {
                    return String(availHeight) + "px";
                  }));
          }), []);
    const $$document = signable.document;
    const match$4 = Belt__Belt_Option.getExn(signable.participant).sign_status;
    const doc = signable.document;
    let tmp;
    if (doc !== undefined) {
      const participant = signable.participant;
      tmp = participant !== undefined ? JsxRuntime.jsx(Buhta_cabinet__SignDocumentInfo.make, {
              doc: doc,
              participant: participant
            }) : null;
    } else {
      tmp = null;
    }
    const __x = data.signables;
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("img", {
                                className: "w-6 h-6",
                                alt: "docs",
                                src: StaticAsset.src("/static/icons/docs-white-24.svg")
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                className: "text-white whitespace-nowrap overflow-hidden overflow-ellipsis",
                                children: Belt__Belt_Option.getExn(signable.document).name
                              })
                        ],
                        className: "bg-black p-4 flex gap-3 items-center"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        children: "Документ " + (
                                          $$document !== undefined ? $$document.document_num : ""
                                        )
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                              className: "text-default-gray",
                                              children: match$4 >= 2 ? "Подписан" : "Не подписан"
                                            }),
                                        className: "px-2 py-0.5 bg-gray-pale rounded-3xl inline-block"
                                      })
                                ],
                                className: "space-y-2"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("img", {
                                      className: Cn.fromList({
                                            hd: "w-5 h-5 transition-transform",
                                            tl: {
                                              hd: dropdownVisible ? "" : "-rotate-90",
                                              tl: /* [] */0
                                            }
                                          }),
                                      alt: "print",
                                      src: StaticAsset.src("/static/icons/dropdown-black-20.svg")
                                    })
                              })
                        ],
                        className: "bg-white px-4 py-2.5 flex justify-between items-center text-left shadow-kkms z-10",
                        onClick: (function (param) {
                            Curry._1(setDropdownVisible, (function (param) {
                                    return !dropdownVisible;
                                  }));
                          })
                      }),
                  JsxRuntime.jsx("div", {
                        children: tmp,
                        className: Cn.fromList({
                              hd: "absolute top-[124px] left-0 bottom-0 bg-white border-t border-gray-main w-full px-4 py-6 overflow-auto z-20",
                              tl: {
                                hd: dropdownVisible ? "" : "hidden",
                                tl: /* [] */0
                              }
                            })
                      }),
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__PdfCanvas.make, {
                                    multi: true,
                                    hash: signable.hash,
                                    previewUrl: previewUrl,
                                    orientation: Belt__Belt_Option.getExn(signable.document).orientation
                                  }),
                              className: "p-4 w-full"
                            }),
                        className: "w-full overflow-auto mb-[234px]"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                children: "Документов на подпись: " + String(Belt__Belt_List.length(data.signables))
                              }),
                          JsxRuntime.jsx("div", {
                                children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, signable) {
                                            const $$document = signable.document;
                                            if ($$document === undefined) {
                                              return null;
                                            }
                                            const Key = "file-" + String(index);
                                            const match = $$document.source_type;
                                            const match$1 = activeFile === index;
                                            let tmp = match === "pdf_file" ? (
                                                match$1 ? "/static/icons/file-pdf-white-24.svg" : "/static/icons/file-pdf-gray-24.svg"
                                              ) : (
                                                match$1 ? "/static/icons/file-doc-white-24.svg" : "/static/icons/file-doc-gray-24.svg"
                                              );
                                            return JsxRuntime.jsxs("button", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: JsxRuntime.jsx("img", {
                                                                      className: "w-6 h-6",
                                                                      alt: "file-pdf",
                                                                      src: StaticAsset.src(tmp)
                                                                    }),
                                                                className: "flex justify-between w-full"
                                                              }),
                                                          JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                                                className: activeFile === index ? "text-white" : "text-asphalt",
                                                                children: $$document.name
                                                              })
                                                        ],
                                                        className: Cn.fromList({
                                                              hd: "rounded-md px-2 py-3 shadow-kkms w-32 space-y-4 border border-gray-main flex flex-col justify-between shrink-0",
                                                              tl: {
                                                                hd: activeFile === index ? "bg-asphalt-dark" : "",
                                                                tl: /* [] */0
                                                              }
                                                            }),
                                                        onClick: (function (param) {
                                                            Curry._1(setActiveFile, (function (param) {
                                                                    return index;
                                                                  }));
                                                          })
                                                      }, Key);
                                          }))),
                                className: "flex gap-4 overflow-auto"
                              }),
                          JsxRuntime.jsx(Buhta_cabinet__ButtonPrimaryMobile.make, {
                                title: "Подписать все документы",
                                onClick: (function (param) {
                                    Curry._1(setSignModalVisible, (function (param) {
                                            return true;
                                          }));
                                  })
                              })
                        ],
                        className: "w-full p-4 absolute bottom-0 bg-white space-y-4 z-10 shadow-kkms"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                        className: "text-center",
                                        children: "QR для eGov Mobile"
                                      }),
                                  JsxRuntime.jsx(QrcodeReact, {
                                        value: "mobileSign:https://buhta.com/mgovSign/" + code,
                                        renderAs: "svg",
                                        className: "w-36"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("ol", {
                                              children: [
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "inline",
                                                            children: "Откройте приложение eGov Mobile"
                                                          })
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "inline",
                                                            children: "Отсканируйте QR-код"
                                                          })
                                                    }),
                                                JsxRuntime.jsx("li", {
                                                      children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            className: "inline",
                                                            children: "Подпишите документ"
                                                          })
                                                    })
                                              ],
                                              className: "list-decimal list-inside font-normal text-sm text-gray-medium"
                                            }),
                                        className: "w-full"
                                      })
                                ],
                                className: "border border-gray-light rounded px-4 pt-6 pb-4 w-full space-y-6 flex flex-col items-center"
                              }),
                          JsxRuntime.jsxs("a", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                                className: "text-left text-white",
                                                children: "eGov Mobile"
                                              }),
                                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                className: "text-white/40 text-left",
                                                children: "Подписать в приложении"
                                              })
                                        ],
                                        className: "space-y-1"
                                      }),
                                  JsxRuntime.jsx("img", {
                                        className: "w-6 h-6",
                                        alt: "egov-mobile",
                                        src: StaticAsset.src("/static/icons/egov-mobile-24.svg")
                                      })
                                ],
                                className: "bg-links rounded px-4 py-2 w-full flex justify-between items-center mt-4 select-none hover:bg-links-hover active:bg-links-active",
                                href: "https://mgovsign.page.link/?link=https://buhta.com/mgovSign/" + code + "&apn=kz.mobile.mgov&isi=1476128386&ibi=kz.egov.mobile"
                              }),
                          JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                      children: "Отмена"
                                    }),
                                className: "flex justify-center gap-2 rounded border border-gray-main py-2.5 w-[calc(100%-48px)] absolute bottom-6 left-6 select-none",
                                onClick: (function (param) {
                                    Curry._1(setSignModalVisible, (function (param) {
                                            return false;
                                          }));
                                  })
                              })
                        ],
                        className: Cn.fromList({
                              hd: "fixed inset-0 bg-white z-20 p-6",
                              tl: {
                                hd: match$3[0] ? "" : "hidden",
                                tl: /* [] */0
                              }
                            })
                      })
                ],
                className: "bg-gray-pale flex flex-col relative",
                style: {
                  height: match$1[0]
                }
              });
  };
}

function SignFlowMobileMulti(Props) {
  return make(Props.data)(Props.code);
}

const make$1 = SignFlowMobileMulti;

export {
  make$1 as make,
}
/* Buhta_cabinet__ButtonPrimaryMobile Not a pure module */
